import React from "react";

type Props = { children: string; max?: number };

const TruncateText: React.FC<Props> = ({ children, max = 150 }) => (
  <>{children.length > max ? `${children.substring(0, max)}...` : children}</>
);

export default TruncateText;
